<div class="flex flex-col gap-3 md:gap-4" [formGroup]="formGroup">
    <h2 class="text-base text-shui-text-strong font-semibold m-0 my-2 p-0">
        {{ 'iro.standard-deal.title' | translate }}
    </h2>
    <div class="flex flex-col gap-4 mt-4">
        <sh-input-text
            formControlName="quoteNumber"
            [label]="'iro.standard-deal.quote-contract-number-label' | translate"
            mandatory
        ></sh-input-text>
        <div class="flex justify-end mt-2">
            <sh-button
                [label]="'iro.standard-deal.query-onedx' | translate"
                icon="search"
                icon-position="start"
                size="max-content"
                [disabled]="!canQuery() || loading()"
                (click)="queryOneDx()"
            ></sh-button>
        </div>
    </div>
    @if (loading() || rowData().length !== 0) {
        <div class="w-full h-px bg-shui-base-4 my-8"></div>
        <h2 class="text-base text-shui-text-strong font-semibold m-0 my-2 p-0">
            {{ 'iro.standard-deal.customer-information' | translate }}
        </h2>
        @if (loading()) {
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 bg-shui-base-2 rounded-md p-6">
                @for (i of [1, 2, 3, 4]; track i) {
                    <div class="flex flex-col gap-1">
                        <div class="h-3 w-24 bg-shui-base-3 rounded animate-pulse"></div>
                        <div class="h-4 w-48 bg-shui-base-3 rounded animate-pulse mt-1"></div>
                    </div>
                }
            </div>
        } @else if (customerInformation()) {
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 bg-shui-base-2 rounded-md p-6">
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{ 'common.general.customer-name' | translate }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        customerInformation()!.customerName
                    }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'iro.standard-deal.quote-contract-number' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        customerInformation()!.quoteContractNumber
                    }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'iro.standard-deal.sold-to-address' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        customerInformation()!.soldToAddress
                    }}</span>
                </div>
                <div class="flex flex-col gap-0">
                    <span class="text-xs text-shui-text-subtle">{{
                        'iro.standard-deal.ship-to-address' | translate
                    }}</span>
                    <span class="text-sm text-shui-text-strong font-medium">{{
                        customerInformation()!.shipToAddress
                    }}</span>
                </div>
            </div>
        }
        <div class="w-full h-px bg-shui-base-4 my-8"></div>
        <div class="flex justify-between items-center gap-2 mb-2">
            <h2 class="text-base text-shui-text-strong font-semibold m-0 my-2 p-0">
                {{ 'iro.standard-deal.material-information' | translate }}
            </h2>
            <span class="text-sm text-shui-text-subtle">{{ 'iro.standard-deal.auto-populated-hint' | translate }}</span>
        </div>
        @if (loading()) {
            <div class="w-full flex flex-col gap-0">
                <div class="h-10 w-full bg-shui-base-3 rounded-t animate-pulse"></div>
                @for (i of [1, 2, 3]; track i) {
                    <div class="h-12 w-full bg-shui-base-2 animate-pulse border-t border-shui-base-2"></div>
                }
            </div>
        } @else {
            <div class="w-full h-[500px]">
                <ag-grid-angular
                    [gridOptions]="gridOptions"
                    [rowData]="rowData()"
                    [columnDefs]="colDefs"
                    (cellValueChanged)="onCellValueChanged($event)"
                    class="w-full h-full"
                />
            </div>
        }
        @if (showContinue()) {
            <div class="mt-2 flex items-center justify-end">
                <sh-button
                    [label]="'common.general.continue' | translate"
                    [disabled]="formGroup.invalid"
                    (click)="onContinue()"
                ></sh-button>
            </div>
        }
    }
</div>
